import React, { useEffect, useState, type FormEvent } from "react";
import Button from "./components/Button";
import { GrSend } from "react-icons/gr";
import uilayout from "/assets/ui-layout.png";
import lowPrice from "/assets/low-price.png";
import unlimitedTime from "/assets/unlimited-time.png";
import qa1 from "/assets/qa1.png";
import qa2 from "/assets/qa2.png";
import qa3 from "/assets/qa3.png";
import footer_logo from "/assets/footer_logo.png";
import customer_support from "/assets/customer_support.png";
import customer_support2 from "/assets/customer_support2.png";
import { FiMenu } from "react-icons/fi";
import { features } from "./utils/features";
import { businesses, importantParts } from "./utils/constants";
import QuestionAndAnswers from "./components/QuestionAndAnswers";
import market from "/assets/icons/market.png";
import clothesStore from "/assets/icons/clothes-store.png";

function App() {
  const [focusedFeatureIndex, setFocusedFeatureIndex] = useState(0);
  const [focusedImportantPartIndex, setFocusedImportantPartIndex] = useState(0);
  const [importantPartsRepeated, setImportantPartsRepeated] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitDisable, setSubmitDisable] = useState(false);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const animatedWords = [{
    word: "رێکخستی تر...",
    ch: 13,
    duration: "3s"
  }, {
    word: "دەقیق تر...",
    ch: 10,
    duration: "3s",
  }, {
    word: "بلەزتر...",
    ch: 7,
    duration: "3s"
  }];
  // const [wordIndex, setWordIndex] = useState(0);

  // const typingRef = useRef<HTMLParagraphElement>(null);

  // useEffect(() => {
  //   if (!typingRef.current) return;

  //   const observer = new ResizeObserver(([entry]) => {
  //     if (entry.contentRect.width === 0) {
  //       setWordIndex((prev) => (prev + 1) % animatedWords.length);
  //     }
  //   });

  //   observer.observe(typingRef.current);
  // }, []);

  useEffect(() => {
    const focusedFeatureInterval = setInterval(() => {
      setFocusedFeatureIndex((prevIndex) => (prevIndex === features.length - 1 ? 0 : prevIndex + 1));
    }, 3000);
    return () => {
      clearInterval(focusedFeatureInterval);
    }; // cleanup
  }, []); // second argument is dependency array

  useEffect(() => {
    setSubmitDisable(name.length === 0 || phoneNumber.length === 0);
  }, [name, phoneNumber]);

  useEffect(() => {
    if (!importantPartsRepeated) return; // stop running

    const interval = setInterval(() => {
      setFocusedImportantPartIndex((prev) => (prev === importantParts.length - 1 ? 0 : prev + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, [importantPartsRepeated]);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    setSubmitDisable(true);
    setError(null);
    setSuccess(false);

    const form = e.currentTarget;
    const formData = new FormData(form);

    const data = {
      name: String(formData.get("name") || ""),
      phone: String(formData.get("phone") || ""),
      message: String(formData.get("message") || ""),
    };

    try {
      await submitContactForm(data);
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        form.reset();
      }, 4000);
    } catch (error) {
      console.log(error);
      setError("خەلەتیەک روویدا، هیڤی یە دووبارە هەوڵ بدە");
    } finally {
      setSubmitDisable(false);
    }
  }

  async function submitContactForm(data: { name: string; phone: string; message?: string }) {
    const res = await fetch("https://telegram-contact.bahman-kadhim-dev.workers.dev", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      console.log(res);
      throw new Error("Submission failed");
    }

    return res.json();
  }

  return (
    <div className="min-h-screen transition-all duration-500 bg-white text-gray-900">
      <div
        className={`fixed inset-0 z-999 flex flex-col justify-center items-center
              bg-qs-primary-two text-white transition-opacity duration-500
              ${success ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
      >
        {" "}
        <p className="text-3xl font-family-noto-kufi text-cente block">سوپاس بو پەیوەندیا تە...</p>
        <p className="text-3xl font-family-noto-kufi text-center block mt-10">دێ ب زیترین دەم بەرسڤاتە هێتە دان.</p>
      </div>

      {/* Navigation */}
      <nav className="fixed w-full z-50 transition-all duration-300 bg-white  border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-6 flex flex-col">
          <div className="flex flex-row-reverse justify-between items-center h-16">
            <a href=".">
              <img src="/assets/nav-logo.png" alt="" width={114} height={33} />
            </a>
            <div className="hidden md:flex gap-7 text-md">
              <a href="#features" className="cursor-pointer hover:scale-105 hover:text-qs-primary-two transition duration-300">
                تایبەتمەندی
              </a>
              <a href="#qa" className="cursor-pointer hover:scale-105 hover:text-qs-primary-two transition duration-300">
                پرسیار
              </a>
              <a href="#contact-us" className="cursor-pointer hover:scale-105 hover:text-qs-primary-two transition duration-300">
                پەیوەندی
              </a>
            </div>
            <div className="hidden md:flex gap-4">
              {/* <Button className="bg-qs-light-gray p-3 h-10 rounded-md flex rtl:flex-row-reverse gap-1.5 items-center">
                <GrLanguage className="size-5" />
                <p>Ku</p>
              </Button> */}
              <Button className="bg-linear-to-r h-10 from-qs-primary-one to-qs-primary-two p-3 rounded-md flex rtl:flex-row-reverse gap-1.5 items-center text-white px-5">
                <a href="#contact-us">پەیوەندی</a>
              </Button>
            </div>

            {/* Mobile menu button */}
            <button
              className="md:hidden p-2"
              onClick={() => {
                setIsMenuOpen((v) => (v = !v));
              }}
            >
              <FiMenu className="text-2xl" />
            </button>
          </div>

          <div
            className={`
              md:hidden overflow-hidden transition-all duration-300 ease-in-out gap-6 flex flex-col
              ${isMenuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}
            `}
          >
            <a
              onClick={() => {
                setIsMenuOpen(false);
              }}
              className="block"
              href="#features"
            >
              تایبەتمەندی
            </a>
            <a
              onClick={() => {
                setIsMenuOpen(false);
              }}
              href="#qa"
              className="block"
            >
              پرسیار
            </a>

            {/* <Button className="bg-qs-light-gray p-3 rounded-md flex rtl:flex-row-reverse gap-1.5 items-center justify-center">
              <GrLanguage className="size-5" />
              <p>Ku</p>
            </Button> */}

            <Button className="mb-8 max-w-40 bg-linear-to-r from-qs-primary-one to-qs-primary-two p-3 rounded-md flex rtl:flex-row-reverse gap-1.5 items-center text-white justify-center">
              <a href="#contact-us" onClick={() => setIsMenuOpen(false)}>
                پەیوەندی
              </a>
            </Button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="hero" className="relative pt-20 pb-12 px-4 sm:px-6 lg:px-8 bg-[url('/assets/hero-pattern.svg')]  repeat bg-cover bg-center">
        {/* Fade top & bottom */}
        <div className="absolute inset-0 z-0 bg-linear-to-b from-white via-transparent from-5% via-50% to-100% to-white pointer-events-none"></div>
        {/* Reduce opacity overlay */}
        <div className="absolute inset-0 bg-white/70 pointer-events-none"></div>

        <div className="relative max-w-7xl mx-auto px-4 flex flex-col-reverse lg:flex-row">
          <div className="w-full text-center lg:text-right lg:w-1/2 mt-4 md:mt-10 lg:mt-20">
            <div className="animate-fade-in-up">
              <div className="flex flex-col text-3xl md:text-4xl font-family-noto-kufi font-black">
                <p>دەم هات کرین و فروتنێت خو</p>
                <div className="flex justify-center lg:justify-start mt-2 md:mt-6 ">
                  <p className="leading-relaxed typing text-qs-primary-two" style={{"--chars": animatedWords[0].ch, "--duration": animatedWords[0].duration} as React.CSSProperties}>
                    <span className="bg-linear-to-r from-qs-primary-one to-qs-primary-two bg-clip-text text-transparent">{animatedWords[0].word}</span>
                  </p>
                  <p className="ms-4 leading-relaxed">لێبکەی</p>
                </div>
              </div>
              <p className="mt-4 md:mt-10 w-full text-gray-500 font-family-vazirmatn md:text-xl">
                سیستەمێ کاشێر و ژمێریاری کو دشێت ئالوزیا سەرەدەری کرنا تە دگەل حساباتێن کرین و فروتنێ, جەردا کەرەستان و داهات و مەزاختنێن تە رێک پێخیت و دەمی بوتە بزڤرینیت!.
              </p>
              <div className="flex items-stretch justify-center lg:justify-start mt-15">
                <Button className="bg-linear-to-r flex items-center h-13 from-qs-primary-one to-qs-primary-two p-3 rounded-md gap-1.5  text-white px-10">
                  <a href="#contact-us">پەیوەندی</a>
                </Button>
                <Button className="bg-white whitespace-nowrap border-gray-500 border p-3 ms-5 rounded-md rtl:flex-row-reverse gap-1.5  text-gray-700 px-10">
                  <a href="#features">زانیاریێن زێدەتر</a>
                </Button>
              </div>
            </div>
          </div>
          {/* <div className="w-full lg:w-1/2 relative mt-15 lg:mt-30">
            <img src="src/assets/pos-icon-hero.png" alt="" className="relative mx-auto z-10 float3 drop-shadow-2xl scale-90 lg:scale-100" width={310} height={250} />
            <img src="src/assets/barcode-icon-hero.png" alt="" className="absolute top-0 -end-5 z-0 float2 scale-90 lg:scale-100" width={250} height={407} />
            <img src="src/assets/scanner-icon-hero.png" alt="" className="absolute -top-25 -start-5 float drop-shadow-lg scale-90 lg:scale-100" width={300} height={407} />
          </div> */}
          <div className="w-full lg:w-1/2 relative mt-10 md:mt-15 lg:mt-30 flex flex-row justify-center items-center pr-0 lg:pr-80">
            <img src="/assets/scanner-icon-hero.webp" alt="" className="-translate-x-16 md:-translate-x-24 lg:translate-x-5 -translate-y-10 md:-translate-y-24 z-0 float2 w-36 md:w-56 lg:w-74" />
            <img src="/assets/pos-icon-hero.webp" alt="" className="lg:translate-x-32 z-10 float3 drop-shadow-2xl w-44 md:w-60 lg:w-80" />
            <img
              src="/assets/barcode-icon-hero.webp"
              alt=""
              className="translate-x-14 md:translate-x-20 lg:translate-x-60 translate-y-0 md:-translate-y-20 float drop-shadow-lg w-32 md:w-48 lg:w-60"
            />
          </div>
        </div>
      </section>

      {/* overview Section */}
      <section id="overview" className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <div className="text-3xl font-black font-family-noto-kufi">
              <h2>
                هەر تشتەکێ کو تو پێدڤیی بو <span className="bg-linear-to-r from-qs-primary-one to-qs-primary-two bg-clip-text text-transparent">سەرکەفتنێ</span>
              </h2>
              <p className="mt-4 w-full text-gray-500 font-family-vazirmatn text-lg md:text-xl font-normal">تایبەتمەندی یێت گشتگیر کو بو رێکخستن و بەرەڤ پێشچوونا کارێن تە هاتینە دارێژتن</p>
            </div>
            <div className="mt-10 flex flex-wrap justify-center gap-6 items-stretch">
              {features.map((feature, index) => (
                <div key={index} className="flex w-[23%] min-w-[300px]">
                  <div
                    className={`border rounded-md border-gray-300 p-6 transition-all duration-500 ease-in-out ${
                      focusedFeatureIndex === index ? "bg-linear-to-br from-qs-primary-light-one to-qs-primary-light-two border drop-shadow-2xl border-qs-primary-one" : ""
                    }`}
                  >
                    {React.cloneElement(feature.icon, {
                      className: `w-6 h-6 text-qs-primary-one`,
                    })}
                    <div className="text-start flex flex-col gap-2 mt-2 font-family-vazirmatn">
                      <h3 className="font-black">{feature.title}</h3>
                      <p className="mt-1 text-qs-text-dark-gray">{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Businesses */}
      <section id="businesses" className="px-4 sm:px-6 lg:px-8 mt-15">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-center mb-16 text-3xl font-black font-family-noto-kufi">
            هەر <span className="bg-linear-to-r from-qs-primary-one to-qs-primary-two bg-clip-text text-transparent">بیزنێسەکا</span> تەهەبیت
          </h2>
          <div className="mt-10 flex flex-wrap justify-center gap-6 mb-16">
            {businesses.map((bussiness, index) => (
              <div key={index} className="flex w-[23%] min-w-[200px]">
                <div className="border py-10 flex flex-col items-center w-full rounded-md border-gray-300 p-6 transition-all duration-500 ease-in-out">
                  <img
                    src={bussiness.icon}
                    width={bussiness.iconWidth}
                    height={bussiness.iconHeight}
                    className={`text-qs-primary-one ${bussiness.icon === clothesStore ? "scale-85" : ""} ${bussiness.icon === market ? "scale-130" : ""}`}
                  />
                  <div className="text-start flex flex-col gap-2 mt-5 font-family-vazirmatn">
                    <h3>{bussiness.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why */}
      <section id="why" className="mt-30 bg-linear-to-r from-qs-primary-one to-qs-primary-two mt20">
        <div className=" bg-[url('/assets/why-pattern.svg')] repeat bg-cover bg-center">
          <div className="py-10">
            <div className="max-w-7xl mx-auto flex flex-col items-center">
              <h2 className="font-family-noto-kufi text-3xl font-black  text-white">بوچی QuickSell ؟</h2>
              <div className="mt-15 flex flex-wrap justify-center gap-30">
                <div className="flex flex-col items-center w-[23%] min-w-[200px] justify-center">
                  <img width={55} height={55} src={uilayout} alt="" />
                  <h1 className="text-center mt-5 text-white font-family-vazirmatn text-lg">روکارەکێ کەشخە و سادە کو کارکرن پێ گەلەک ساناهی دکەت</h1>
                </div>
                <div className="flex flex-col items-center w-[20%] min-w-[200px] justify-center">
                  <img width={65} height={65} src={lowPrice} alt="" />
                  <h1 className="text-center mt-5 text-white font-family-vazirmatn text-lg">بهایەکێ گونجایی لدیف ئەپلیکەیشنێت دی</h1>
                </div>
                <div className="flex flex-col items-center w-[20%] min-w-[200px] justify-center">
                  <img width={60} height={60} src={unlimitedTime} alt="" />
                  <h1 className="text-center mt-5 text-white font-family-vazirmatn text-lg">مافێ بکارئینانێ بو هەتا هەتایێ بێ نیکرن</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Important Parts */}
      <section id="features" className="mt-25 max-w-7xl mx-auto">
        <h2 className="text-center text-3xl font-black font-family-noto-kufi">
          گرنگترین <span className="bg-linear-to-r from-qs-primary-one to-qs-primary-two bg-clip-text text-transparent">بەشێن </span> ئەپلیکەیشنی
        </h2>
        <div className="mt-10 flex flex-wrap justify-center gap-6">
          {importantParts.map((feature, index) => (
            <div
              key={index}
              className="flex"
              onMouseEnter={() => {
                setFocusedImportantPartIndex(index);
                setImportantPartsRepeated(false);
              }}
              onClick={() => {
                setImportantPartsRepeated(false);
                setFocusedImportantPartIndex(index);
              }}
            >
              <div
                className={`cursor-pointer border flex flex-col items-center w-full rounded-lg border-gray-300 px-6 py-4 transition-all duration-500 ease-in-out ${
                  index == focusedImportantPartIndex ? "bg-gradient-to-r from-qs-primary-one to-qs-primary-two drop-shadow-2xl" : ""
                }`}
              >
                <div className="text-start flex flex-col gap-2 font-family-vazirmatn">
                  <h3 className={`${index == focusedImportantPartIndex ? "text-white" : ""}`}>{feature.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col lg:flex-row gap-6 justify-center items-center">
          <div
            key={focusedImportantPartIndex} // <--- forces animation on change
            className="
                w-full lg:w-1/3 p-6 rounded-xl mt-10 lg:mt-0
                animate-[fadeIn_0.7s_ease-out_forwards] lg:h-auto h-54
              "
          >
            <h1 className="font-black text-qs-primary-two text-2xl font-family-noto-kufi">{importantParts[focusedImportantPartIndex].title}</h1>

            <p className="text-qs-text-dark-gray font-family-vazirmatn mt-4">{importantParts[focusedImportantPartIndex].description}</p>
          </div>

          <div
            key={focusedImportantPartIndex + "-image"}
            className="
                w-full lg:flex-1 rounded-xl lg:py-14 px-5 xl:px-0
                animate-[fadeIn_0.7s_ease-out_forwards]
              "
          >
            <div className="aspect-[16/10] w-full">
              <img src={importantParts[focusedImportantPartIndex].img} alt="" className="w-full h-full object-cover rounded-2xl border border-gray-200 shadow-2xl" />
            </div>{" "}
          </div>
        </div>
      </section>

      {/* Section Q&A */}
      <section id="qa" className="my-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:gap-6 items-center">
          <div className="w-full lg:w-1/3 flex flex-col items-center">
            <img className="scale-50 lg:scale-100" width={150} src={qa3} alt="" />
            <img className="hidden lg:flex self-start" width={130} src={qa2} alt="" />
            <img width={110} className="hidden lg:flex" src={qa1} alt="" />
          </div>
          <div className="w-full lg:flex-1 flex flex-col">
            <h2 className="text-center lg:text-start text-3xl font-black font-family-noto-kufi">
              بەرسڤا <span className="bg-linear-to-r from-qs-primary-one to-qs-primary-two bg-clip-text text-transparent">پرسیاڕێن </span> دوبارە
            </h2>
            <div className="mt-10 px-5 xl:px-0">
              <QuestionAndAnswers />
            </div>
          </div>
        </div>
      </section>

      {/* Section Contact-us */}
      <section id="contact-us" className="my-25 max-w-7xl mx-auto">
        <h2 className="text-center text-3xl font-black font-family-noto-kufi">
          تە دڤێت <span className="bg-linear-to-r from-qs-primary-one to-qs-primary-two bg-clip-text text-transparent">پەیوەندیێ </span> ب مە بکەی؟
        </h2>
        <p className="mt-4 w-full text-center text-gray-500 font-family-vazirmatn text-xl font-normal">
          ئەگەر تە پرسیارەک هەبیت ئان تو پێدڤی پێزانینێن زێدەتری, فورما بنی دا بگرە دێ ب زیترین دەم پەیوەندیێ ب تە کەین.
        </p>
        <div className="flex flex-col lg:flex-row gap-6 items-center bg-[url('/assets/contact-us-pattern1.svg')] bg-no-repeat bg-cover bg-[#ED7474] py-10 mt-10 rounded-md relative px-10 md:px-20">
          <form onSubmit={handleSubmit} className="w-full lg:flex-1 flex gap-6 flex-col items-center justify-center">
            <div className="w-full flex flex-col md:flex-row gap-6">
              <div className="flex flex-col gap-2 flex-1">
                <p className="font-family-vazirmatn text-white">ناڤێ تە*</p>
                <input
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  name="name"
                  type="text"
                  className="bg-white rounded-sm py-2 px-5 outline-none focus:shadow-lg"
                />
              </div>
              <div className="flex flex-col gap-2 flex-1">
                <p className="font-family-vazirmatn text-white">موبایل*</p>
                <input
                  onChange={(e) => {
                    setPhoneNumber(e.target.value);
                  }}
                  name="phone"
                  type="number"
                  className="bg-white rounded-sm py-2 px-5 outline-none focus:shadow-lg"
                />
              </div>
            </div>

            <div className="flex flex-col gap-2 w-full">
              <p className="font-family-vazirmatn text-white">ناڤ و نیشانێن جهێ تە</p>
              <input name="address" type="text" className="bg-white rounded-sm py-2 px-5 outline-none focus:shadow-lg" />
            </div>

            <div className="flex flex-col gap-2 w-full">
              <p className="font-family-vazirmatn text-white">تێبینی ئان پرسیارەک ئەگەر تە هەبیت</p>
              <textarea name="message" className="bg-white rounded-sm py-2 px-5 outline-none focus:shadow-lg" />
            </div>

            <Button
              disabled={submitDisable}
              type="submit"
              className="bg-qs-light-gray w-full sm:w-auto py-6 self-start px-10 h-10 rounded-md flex rtl:flex-row-reverse gap-3 items-center justify-center cursor-pointer disabled:cursor-default disabled:opacity-50"
            >
              <GrSend className="size-5" />
              <p>هنارتن</p>
            </Button>

            {error && <p className="w-full bg-red-100 p-2 rounded-md text-red-500 font-family-noto-kufi">{error}</p>}
          </form>

          <div className="w-full hidden lg:flex lg:w-1/3 relative justify-center">
            <img className="absolute -bottom-15 right-0 float" width={230} src={customer_support2} alt="" />
            <img className="absolute -top-30 start-30 float3" width={270} src={customer_support} alt="" />
          </div>
        </div>
      </section>

      <section id="footer">
        <div className="w-full flex flex-col items-center px-4 py-10 bg-[#FDF4EF] sm:px-6 lg:px-6">
          <img className="" src={footer_logo} width={80} height={80} alt="" />
          <p className="text-sm mt-2 text-gray-600" dir="ltr">
            &copy; 2025 QuickSell. All rights reserved
          </p>
        </div>
      </section>
    </div>
  );
}

export default App;
